import { NgFor, NgIf } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IconOption, IconPickerComponent } from "src/app/components/shared/icon-picker/icon-picker.component";
import { AddCatalogItemBenefit } from "src/app/models/catalogs/catalog";
import { DropdownOption } from "src/app/models/shared/dropdown-option";
import Swal from "sweetalert2";

@Component({
  selector: "app-benefits-step",
  standalone: true,
  templateUrl: "./benefits-step.component.html",
  styleUrls: ["./benefits-step.component.css"],
  imports: [FormsModule, NgFor, NgIf, IconPickerComponent],
})
export class BenefitsStepComponent implements OnInit {
  @Input() public isReadonly: boolean = false;
  @Input() data: any = {};
  @Output() dataChange = new EventEmitter<any>();
  @Input() faIconsOptions: DropdownOption[] = [];

  get iconOptionsMapped(): IconOption[] {
    return (this.faIconsOptions || []).map((x, idx) => ({
      id: x.id ?? idx,
      text: x.text,
      keywords: x.description || ''
    }));
  }

  requiredBenefits = 2;

  benefits: AddCatalogItemBenefit[] = [
    {
      id: null,
      versionId: this.data?.versionId ?? 0,
      shortText: "",
      iconName: "",
      sortOrder: 1,
      title: "",
      isEnabled: true
    },
    {
      id: null,
      versionId: this.data?.versionId ?? 0,
      shortText: "",
      iconName: "",
      sortOrder: 2,
      title: "",
      isEnabled: true
    }
  ];

  ngOnInit(): void {
    const incoming = this.data as AddCatalogItemBenefit[] | undefined;
    if (Array.isArray(incoming) && incoming.length) {
      this.benefits = incoming
        .map((b, i) => ({
          id: b.id ?? null,
          versionId: this.data?.versionId ?? 0,
          shortText: b.shortText ?? "",
          iconName: b.iconName ?? "fas fa-check-circle",
          sortOrder: b.sortOrder ?? i + 1,
          title: b.shortText,
          isEnabled: b.isEnabled
        }))
        .sort((a, b) => a.sortOrder - b.sortOrder);
    } else {
      this.benefits.forEach((b, i) => (b.sortOrder = i + 1));
    }
  }

  addBenefit() {
    const itm: AddCatalogItemBenefit = {
      id: null,
      versionId: this.data?.versionId ?? 0,
      shortText: "",
      iconName: "fas fa-check-circle",
      sortOrder: this.benefits.length + 1,
      title: "",
      isEnabled: true
    };
    this.benefits = [...this.benefits, itm];
    this.updateData();
  }

  removeBenefit(index: number) {
    if (this.benefits.length <= 1) return;
    this.benefits.splice(index, 1);
    this.benefits.forEach((b, i) => (b.sortOrder = i + 1));
    this.benefits = [...this.benefits];
    this.updateData();
  }

  moveUp(i: number) {
    if (i === 0) return;
    [this.benefits[i - 1], this.benefits[i]] = [this.benefits[i], this.benefits[i - 1]];
    this.benefits.forEach((b, idx) => (b.sortOrder = idx + 1));
    this.updateData();
  }

  moveDown(i: number) {
    if (i === this.benefits.length - 1) return;
    [this.benefits[i + 1], this.benefits[i]] = [this.benefits[i], this.benefits[i + 1]];
    this.benefits.forEach((b, idx) => (b.sortOrder = idx + 1));
    this.updateData();
  }

  onChange() {
    this.updateData();
  }

  validate() {
    this.updateData();

    const complete = this.benefits.filter(
      b => b.shortText?.trim() && b.iconName?.trim()
    ).length;

    if (complete < this.requiredBenefits) {
      Swal.fire({
        icon: "warning",
        title: "Faltan beneficios",
        text: `Debes completar al menos ${this.requiredBenefits} beneficios (texto corto e icono).`
      });
      return false;
    }

    return true;
  }


  private updateData() {
    this.dataChange.emit([...this.benefits]);
  }

  get completedBenefitsCount(): number {
    return this.benefits.filter(b => b.shortText?.trim() && b.iconName?.trim()).length;
  }


  onIconPicked(i: number, cls: string) {
    this.benefits[i].iconName = cls;
    this.onChange();
  }
}
